import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Calendar from "react-calendar";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

import "react-calendar/dist/Calendar.css";
import "./style.scss";

const propTypes = {
  filter: PropTypes.func,
  setDate: PropTypes.func,
  category: PropTypes.number,
  date: PropTypes.string,
  keyword: PropTypes.string,
  setKeyword: PropTypes.func,
  setSelectedKeyword: PropTypes.func,
  selectedKeyword: PropTypes.array,
};

const Filter = ({ filter, category, keyword, setKeyword, setDate, date }) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const categoryParams = searchParams.get("type");

  const [showCalendar, setShowCalendar] = useState(false);

  const onChange = (date) => {
    setDate(date);
    setShowCalendar(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const dateData = categoryParams === "3" ? false : formData.get("date");
    const data = {
      date: dateData ? new Date(formData.get("date")) : "",
      category:
        formData.get("category") === "none" ? null : formData.get("category"),
      keyword: formData.get("keyword"),
    };
    setShowCalendar(false);
    filter(data);
  };

  const resetFilter = () => {
    setDate("");
    searchParams.delete("category");
    searchParams.delete("date");
    searchParams.delete("keyword");
    setSearchParams(searchParams);
    const data = {};
    filter(data);
  };

  const minDate = () => {
    const someDate = new Date();
    const result = someDate.setDate(someDate.getDate() + 0);
    return new Date(result);
  };
  return (
    <div className="filterWrapper">
      <div className="container">
        <div className="font-bold text-xl mb-2">{t("search_filter")}</div>
        <form onSubmit={handleSubmit} className="lg:w-[80%]">
          <div className="relative flex items-center flex-wrap lg:flex-nowrap gap-3">
            <div className="lg:w-[30%] w-[45%]">
              <Form.Select name="category">
                <option value="none">{t("category")}</option>
                <option value="0">{t("accommodation")}</option>
                <option value="1">{t("activity")}</option>
                <option value="2">{t("restaurant")}</option>
                <option value="3">{t("shopping")}</option>
              </Form.Select>
            </div>
            {category !== 3 && (
              <div className="lg:w-[20%] w-[45%]">
                <Form.Control
                  type="input"
                  name="date"
                  placeholder={t("date_placeholder")}
                  readOnly
                  value={date && moment(date).format("YYYY-MM-DD")}
                  onClick={() => {
                    setShowCalendar(!showCalendar);
                  }}
                />
                <Calendar
                  minDate={minDate()}
                  onChange={(date) => onChange(date)}
                  value={date}
                  className={!showCalendar ? "hide" : ""}
                />
              </div>
            )}
            <div className="lg:w-[30%] w-[45%]">
              <div className="w-100">
                <Form.Control
                  type="text"
                  name="keyword"
                  onClick={() => {
                    setShowCalendar(false);
                  }}
                  className="keywordType"
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder={t("keyword_plc")}
                  value={keyword}
                />
              </div>
            </div>
            <div className="lg:w-fit h-[44px]">
              <button
                className="searchButton bg-black !rounded-none !ml-0 h-full"
                type="submit"
              >
                <FontAwesomeIcon icon={faSearch} />
              </button>
            </div>
          </div>
        </form>
        <button
          type="button"
          className="underline text-sm mt-1"
          onClick={resetFilter}
        >
          {t("reset_filter")}
        </button>
      </div>
    </div>
  );
};

Filter.propTypes = propTypes;

export default Filter;
